import React from 'react';
import { Fade } from 'react-awesome-reveal';

import {
  Accordion,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Container, WysiwygField, AccordionItem } from '../../../components';

import './style.scss';

const FAQ = ({ entity }) => {
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <Container id={paragraphKey} small className="Paragraph">
      <Fade triggerOnce bottom distance="50px" duration={500}>
        <div className="FAQ mt-6">
          <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
          <Accordion>
            {
              entity.get('field_related_content').map((item) => {
                const entityRelated = item.get('entity');

                // Entity could be absent, if this item isn't published on this domain.
                if (!entityRelated) {
                  return;
                }

                return (
                  <AccordionItem
                    entity={entityRelated}
                    key={item.get('target_uuid')}
                    iconClassName="icon-arrow-right icon-variant-2"
                    title={entityRelated.getIn(['title', 0, 'value'])}
                    content={(
                      <WysiwygField html={entityRelated.getIn(['field_answer', 0, 'processed'], '')} />
                    )}
                    titleComponent={({ className, children }) => {
                      return (<h4 className={className}>{children}</h4>);
                    }}
                  />
                );
              })
            }
          </Accordion>
        </div>
      </Fade>
    </Container>
  );
};

export default FAQ;
